import { RoleModuleConfig } from './types';

export const dataManagerModules: RoleModuleConfig = {
  slices: [],
  sagas: {},
};
